import React from "react"
import loadable from "@loadable/component"

const LazyVideoPlayer = loadable(() => import("./index.client"))

const VideoPlayer = (props) => <LazyVideoPlayer {...props} />

export default VideoPlayer
